import { Pipe, PipeTransform,Inject, forwardRef, Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
const Moment = require('moment')
const Cesium = (<any>window).Cesium


@Pipe({
  name: 'localDate',
  pure: false  // required to update the value when currentLang is changed
})
export class LocalizedDatePipe implements PipeTransform {
  private value: string|null;
  private lastDate: any;
  private lastLang: string;

 constructor(private translate: TranslateService) { }

  transform(date: any, format: any){
     const currentLang = this.translate.currentLang;
     var t = <any>(typeof date)
     if(!date)
       return 'Nil';
     // if arg is a date
     else if(format == "!-"){
       return Moment(date).locale(currentLang).fromNow()
     }
     else if(format == "!+"){
       return Moment(date).locale(currentLang).toNow()
     }
     else if(date instanceof Date)
       return Moment(date).locale(currentLang).format(format || 'DD MMM YY HH:mm');
     // otherwise if its a unix time long
     else if(t == 'number')
         return Moment(new Date(date)).locale(currentLang).format(format || 'DD MMM YY HH:mm');
     else {
        console.warn("Unspported MomentDateFormat argument " + date + ' ' + t)
        return date;
     }
  }

}

import {MatPaginatorIntl} from '@angular/material';
@Injectable()
export class MatPaginatorIntlLang extends MatPaginatorIntl {

  pageOf:string
  pageOfLong:string

  constructor(@Inject(forwardRef(() => TranslateService)) private translate: TranslateService){
      super()
     
       this.loadLangs()
       translate.onLangChange.subscribe(s => {
           this.loadLangs()
           this.changes.next()
       })

  }
  loadLangs(){
    
    this.translate.get('FILE_LIST.PAGINATION.itemsPerPage').subscribe(s => this.itemsPerPageLabel = s)
    this.translate.get('FILE_LIST.PAGINATION.nextPage').subscribe(s => this.nextPageLabel = s)
    this.translate.get('FILE_LIST.PAGINATION.previousPage').subscribe(s => this.previousPageLabel = s)
    this.translate.get('FILE_LIST.PAGINATION.lastPage').subscribe(s => this.lastPageLabel = s)
    this.translate.get('FILE_LIST.PAGINATION.firstPage').subscribe(s => this.firstPageLabel = s)

    this.translate.get('FILE_LIST.PAGINATION.pageOf',{current:'$AA',total:'$ZZ'}).subscribe(s => this.pageOf = s)
    this.translate.get('FILE_LIST.PAGINATION.pageOfLong',{currentFrom:'$AA',currentTo:'$BB',total:'$ZZ'}).subscribe(s => this.pageOfLong = s)

  }
  pageLabel(curS,curM,total){
      if(!total)
        return this.pageOf?this.pageOf.replace(/\$AA/g,'' + curS).replace(/\$ZZ/g,'' + curM):''
      else
        return this.pageOfLong?this.pageOfLong.replace(/\$AA/g,'' + curS).replace(/\$BB/g,'' + curM).replace(/\$ZZ/g,'' + total):''
       
  }
  getRangeLabel = function (page, pageSize, length) {
    if (length === 0 || pageSize === 0) {

      return this.pageLabel(0,length)
    } 
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;
    return this.pageLabel(startIndex + 1,endIndex, length);
  };

}



const FILE_SIZE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
const FILE_SIZE_UNITS_LONG = ['Bytes', 'Kilobytes', 'Megabytes', 'Gigabytes', 'Pettabytes', 'Exabytes', 'Zettabytes', 'Yottabytes'];

@Pipe({
  name: 'formatFileSize'
})
export class FormatFileSizePipe implements PipeTransform {

  constructor(private translate: TranslateService) { }

  transform(sizeInBytes: number, longForm: boolean): string {
    const units = longForm
      ? FILE_SIZE_UNITS_LONG
      : FILE_SIZE_UNITS;

    let power = Math.round(Math.log(sizeInBytes) / Math.log(1024));
    power = Math.min(power, units.length - 1);

    const size = sizeInBytes / Math.pow(1024, power); // size in new units
    const formattedSize = Math.round(size * 100) / 100; // keep up to 2 decimals
    const unit = units[power];

    return `${formattedSize} ${unit}`;
  }
}


@Pipe({
  name: 'round'
 // pure: false  // required to update the value when currentLang is changed
})
export class RoundPipe implements PipeTransform {

  transform(data: number, format: any = 1){
    var mag1 = Math.pow(10,parseInt(format))
    var s = '' + Math.round(data*mag1)/mag1
     if(s.indexOf('.') == -1){
       var zeros = ''
       while(zeros.length < format)
         zeros += '0'
       return s + "." + zeros
     }
     else 
       return s
  }

}

@Pipe({
  name: 'deg'
 // pure: false  // required to update the value when currentLang is changed
})
export class DegPipe implements PipeTransform {

  transform(data: number, format: any = 1){
    return Cesium.Math.toDegrees(data)
  }

}
@Pipe({
  name: 'percent'
 // pure: false  // required to update the value when currentLang is changed
})
export class PercentPipe implements PipeTransform {

  transform(data: number, format: any){
     var s = '' + Math.round(data*1000)/10
     if(s.indexOf('.') == -1)
       return s + ".0"
     else 
       return s
  }

}
